// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================== */
/* MAIN CONTAINER & BACKGROUND                */
/* ========================================== */
.olt-list-container { 
    background-color: #0f172a !important;
    min-height: 100vh; 
    color: #f8fafc !important;
    font-family: 'Segoe UI', sans-serif;
    padding: 20px;
    box-sizing: border-box;
}

/* ========================================== */
/* HEADER & SEARCH BAR                        */
/* ========================================== */
/* OLT Management Dashboard Main Title */
.olt-dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
}

.olt-list-header h1 {
    color: #38bdf8 !important;
    font-weight: 700;
}

.olt-list-header h2 {
  color: #38bdf8 !important;
  margin: 0;
}

.olt-search-lavel input {
  margin: 0;
  background: #1e293b !important; 
  border: 1px solid #334155 !important; 
  color: #fff !important; 
  padding: 12px 20px; 
  border-radius: 8px; 
  width: 250px; 
  outline: none;
  font-size: 14px;
}

.olt-search-lavel { 
    text-align: right;
    margin-bottom: 10px; 
    display: flex;
    justify-content: right;
    align-items: right;
    flex-wrap: wrap; 
    gap: 10px; 
}

.olt-search-lavel input:focus {
    border-color: #3b82f6 !important;
}

/* ========================================== */
/* SERVER GROUP & TITLES                      */
/* ========================================== */
.olt-server-group { 
    margin-bottom: 15px; 
}

.olt-server-title { 
    text-align: center;
    font-size: 1.2rem; 
    font-weight: 700; 
    color: #3b82f6 !important; 
    margin-bottom: 10px; 
    border-bottom: 1px solid #1e293b;
    padding-bottom: 8px;
}

/* ========================================== */
/* DEVICE GRID & CARDS                        */
/* ========================================== */
.olt-device-grid { 
    display: grid; 
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); 
    gap: 20px; 
}

.olt-device-card { 
    background: #1e293b !important;
    border-radius: 12px; 
    padding: 20px; 
    border: 1px solid #334155 !important; 
    cursor: pointer; 
    transition: all 0.3s ease; 
}

.olt-device-card:hover { 
    border-color: #3b82f6 !important; 
    transform: translateY(-5px); 
    box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.5);
}

/* Card Header & Text Colors */
.card-top { 
    display: flex; 
    justify-content: space-between; 
    align-items: flex-start; 
    margin-bottom: 15px; 
}

.hostname { 
    margin: 0; 
    font-size: 1.1rem; 
    color: #38bdf8 !important;
    font-weight: 600;
}

.card-info small { 
    color: #94a3b8 !important; 
    font-size: 0.8rem; 
}

/* Status Indicators */
.status-dot { width: 10px; height: 10px; border-radius: 50%; }
.status-dot.online { background: #22c55e; }
.status-dot.offline { background: #ef4444; }
.status-dot.idle { background: #475569; }
.status-dot.loading { background: #f59e0b; animation: pulse 1s infinite; }

@keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }

/* ========================================== */
/* STATS & PROGRESS BARS                      */
/* ========================================== */
.stats-container { display: flex; gap: 15px; margin: 20px 0; }
.stat-item { flex: 1 1; }

.stat-item label { 
    font-size: 0.65rem; 
    color: #94a3b8 !important; 
    margin-bottom: 5px; 
    display: block; 
}

.stat-item span { 
    font-size: 0.7rem; 
    color: #cbd5e1 !important; 
    display: block; 
    margin-top: 3px; 
}

.progress-bg { 
    background: #0f172a !important; 
    height: 6px; 
    border-radius: 3px; 
    overflow: hidden; 
}

.progress-fill { background: #3b82f6; height: 100%; border-radius: 3px; transition: width 0.5s; }
.progress-bg.orange .progress-fill { background: #f97316; }

/* ========================================== */
/* BADGES & FOOTER                            */
/* ========================================== */
.card-badges { display: flex; gap: 8px; align-items: center; margin: 12px 0; flex-wrap: wrap; }
.olt-tech-badge { font-size: 10px; font-weight: 700; padding: 2px 8px; border-radius: 4px; text-transform: uppercase; }
.olt-tech-badge.epon { background: #1d4ed8; color: #fff; }
.olt-tech-badge.gpon { background: #065f46; color: #fff; }

.olt-pop, .access-method { font-size: 11px; color: #64748b; }

.card-footer { 
    border-top: 1px solid #334155 !important; 
    padding-top: 15px; 
    display: flex; 
    justify-content: space-between; 
    font-size: 0.8rem; 
    color: #cbd5e1 !important;
}

.onu-online { color: #22c55e !important; }
.node-details { color: #38bdf8 !important; font-weight: bold; }

.olt-loading { text-align: center; color: #94a3b8; margin-top: 60px; font-size: 14px; }

/* Responsive View */
@media (max-width: 768px) {
    .olt-list-container { padding: 10px; }
    .olt-dashboard-header { flex-direction: column; align-items: stretch; }
    .olt-list-header h1 { width: 90%; box-sizing: border-box; }
    .olt-search-lavel input { width: 90%; box-sizing: border-box; }
    .olt-device-grid { grid-template-columns: 1fr; }
}`, "",{"version":3,"sources":["webpack://./src/components/OLTManage/OLTList.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C,+CAA+C;AAC/C,+CAA+C;AAC/C;IACI,oCAAoC;IACpC,iBAAiB;IACjB,yBAAyB;IACzB,mCAAmC;IACnC,aAAa;IACb,sBAAsB;AAC1B;;AAEA,+CAA+C;AAC/C,+CAA+C;AAC/C,+CAA+C;AAC/C,wCAAwC;AACxC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;EACE,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,gCAAgC;AACpC;;AAEA,+CAA+C;AAC/C,+CAA+C;AAC/C,+CAA+C;AAC/C;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA,+CAA+C;AAC/C,+CAA+C;AAC/C,+CAA+C;AAC/C;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,oCAAoC;IACpC,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA,8BAA8B;AAC9B;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA,sBAAsB;AACtB,cAAc,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;AAC7D,qBAAqB,mBAAmB,EAAE;AAC1C,sBAAsB,mBAAmB,EAAE;AAC3C,mBAAmB,mBAAmB,EAAE;AACxC,sBAAsB,mBAAmB,EAAE,4BAA4B,EAAE;;AAEzE,mBAAmB,QAAQ,SAAS,EAAE,IAAI,WAAW,EAAE;;AAEvD,+CAA+C;AAC/C,+CAA+C;AAC/C,+CAA+C;AAC/C,mBAAmB,aAAa,EAAE,SAAS,EAAE,cAAc,EAAE;AAC7D,aAAa,SAAO,EAAE;;AAEtB;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,iBAAiB,mBAAmB,EAAE,YAAY,EAAE,kBAAkB,EAAE,sBAAsB,EAAE;AAChG,qCAAqC,mBAAmB,EAAE;;AAE1D,+CAA+C;AAC/C,+CAA+C;AAC/C,+CAA+C;AAC/C,eAAe,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE;AAC9F,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE;AACtH,uBAAuB,mBAAmB,EAAE,WAAW,EAAE;AACzD,uBAAuB,mBAAmB,EAAE,WAAW,EAAE;;AAEzD,2BAA2B,eAAe,EAAE,cAAc,EAAE;;AAE5D;IACI,wCAAwC;IACxC,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA,cAAc,yBAAyB,EAAE;AACzC,gBAAgB,yBAAyB,EAAE,iBAAiB,EAAE;;AAE9D,eAAe,kBAAkB,EAAE,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAEtF,oBAAoB;AACpB;IACI,sBAAsB,aAAa,EAAE;IACrC,wBAAwB,sBAAsB,EAAE,oBAAoB,EAAE;IACtE,sBAAsB,UAAU,EAAE,sBAAsB,EAAE;IAC1D,0BAA0B,UAAU,EAAE,sBAAsB,EAAE;IAC9D,mBAAmB,0BAA0B,EAAE;AACnD","sourcesContent":["/* ========================================== */\n/* MAIN CONTAINER & BACKGROUND                */\n/* ========================================== */\n.olt-list-container { \n    background-color: #0f172a !important;\n    min-height: 100vh; \n    color: #f8fafc !important;\n    font-family: 'Segoe UI', sans-serif;\n    padding: 20px;\n    box-sizing: border-box;\n}\n\n/* ========================================== */\n/* HEADER & SEARCH BAR                        */\n/* ========================================== */\n/* OLT Management Dashboard Main Title */\n.olt-dashboard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.olt-list-header h1 {\n    color: #38bdf8 !important;\n    font-weight: 700;\n}\n\n.olt-list-header h2 {\n  color: #38bdf8 !important;\n  margin: 0;\n}\n\n.olt-search-lavel input {\n  margin: 0;\n  background: #1e293b !important; \n  border: 1px solid #334155 !important; \n  color: #fff !important; \n  padding: 12px 20px; \n  border-radius: 8px; \n  width: 250px; \n  outline: none;\n  font-size: 14px;\n}\n\n.olt-search-lavel { \n    text-align: right;\n    margin-bottom: 10px; \n    display: flex;\n    justify-content: right;\n    align-items: right;\n    flex-wrap: wrap; \n    gap: 10px; \n}\n\n.olt-search-lavel input:focus {\n    border-color: #3b82f6 !important;\n}\n\n/* ========================================== */\n/* SERVER GROUP & TITLES                      */\n/* ========================================== */\n.olt-server-group { \n    margin-bottom: 15px; \n}\n\n.olt-server-title { \n    text-align: center;\n    font-size: 1.2rem; \n    font-weight: 700; \n    color: #3b82f6 !important; \n    margin-bottom: 10px; \n    border-bottom: 1px solid #1e293b;\n    padding-bottom: 8px;\n}\n\n/* ========================================== */\n/* DEVICE GRID & CARDS                        */\n/* ========================================== */\n.olt-device-grid { \n    display: grid; \n    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); \n    gap: 20px; \n}\n\n.olt-device-card { \n    background: #1e293b !important;\n    border-radius: 12px; \n    padding: 20px; \n    border: 1px solid #334155 !important; \n    cursor: pointer; \n    transition: all 0.3s ease; \n}\n\n.olt-device-card:hover { \n    border-color: #3b82f6 !important; \n    transform: translateY(-5px); \n    box-shadow: 0 10px 20px -5px rgba(0, 0, 0, 0.5);\n}\n\n/* Card Header & Text Colors */\n.card-top { \n    display: flex; \n    justify-content: space-between; \n    align-items: flex-start; \n    margin-bottom: 15px; \n}\n\n.hostname { \n    margin: 0; \n    font-size: 1.1rem; \n    color: #38bdf8 !important;\n    font-weight: 600;\n}\n\n.card-info small { \n    color: #94a3b8 !important; \n    font-size: 0.8rem; \n}\n\n/* Status Indicators */\n.status-dot { width: 10px; height: 10px; border-radius: 50%; }\n.status-dot.online { background: #22c55e; }\n.status-dot.offline { background: #ef4444; }\n.status-dot.idle { background: #475569; }\n.status-dot.loading { background: #f59e0b; animation: pulse 1s infinite; }\n\n@keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }\n\n/* ========================================== */\n/* STATS & PROGRESS BARS                      */\n/* ========================================== */\n.stats-container { display: flex; gap: 15px; margin: 20px 0; }\n.stat-item { flex: 1; }\n\n.stat-item label { \n    font-size: 0.65rem; \n    color: #94a3b8 !important; \n    margin-bottom: 5px; \n    display: block; \n}\n\n.stat-item span { \n    font-size: 0.7rem; \n    color: #cbd5e1 !important; \n    display: block; \n    margin-top: 3px; \n}\n\n.progress-bg { \n    background: #0f172a !important; \n    height: 6px; \n    border-radius: 3px; \n    overflow: hidden; \n}\n\n.progress-fill { background: #3b82f6; height: 100%; border-radius: 3px; transition: width 0.5s; }\n.progress-bg.orange .progress-fill { background: #f97316; }\n\n/* ========================================== */\n/* BADGES & FOOTER                            */\n/* ========================================== */\n.card-badges { display: flex; gap: 8px; align-items: center; margin: 12px 0; flex-wrap: wrap; }\n.olt-tech-badge { font-size: 10px; font-weight: 700; padding: 2px 8px; border-radius: 4px; text-transform: uppercase; }\n.olt-tech-badge.epon { background: #1d4ed8; color: #fff; }\n.olt-tech-badge.gpon { background: #065f46; color: #fff; }\n\n.olt-pop, .access-method { font-size: 11px; color: #64748b; }\n\n.card-footer { \n    border-top: 1px solid #334155 !important; \n    padding-top: 15px; \n    display: flex; \n    justify-content: space-between; \n    font-size: 0.8rem; \n    color: #cbd5e1 !important;\n}\n\n.onu-online { color: #22c55e !important; }\n.node-details { color: #38bdf8 !important; font-weight: bold; }\n\n.olt-loading { text-align: center; color: #94a3b8; margin-top: 60px; font-size: 14px; }\n\n/* Responsive View */\n@media (max-width: 768px) {\n    .olt-list-container { padding: 10px; }\n    .olt-dashboard-header { flex-direction: column; align-items: stretch; }\n    .olt-list-header h1 { width: 90%; box-sizing: border-box; }\n    .olt-search-lavel input { width: 90%; box-sizing: border-box; }\n    .olt-device-grid { grid-template-columns: 1fr; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
